// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe[data-v-4d07bce5]{position:absolute;top:0;width:100%;height:calc(100vh - var(--header-height))}`, "",{"version":3,"sources":["webpack://./src/views/Ownpad.vue"],"names":[],"mappings":"AACA,wBACC,iBAAA,CACA,KAAA,CACA,UAAA,CACA,yCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
